module.exports = __webpack_public_path__ + "static/media/noisy-city.0d891280.png";